import { Injectable } from '@angular/core';
import { StorageUtil } from './storage.util';
import { Router } from '@angular/router';

@Injectable()
export class AuthUtil {

  constructor(private router: Router) {
  }

  redirect() {
    StorageUtil.clear();
    this.router.navigate(['']);
  }

  checkErrorResponse(response)
  {
      if(this.isError(response)) {
        if(this.errorMessage(response) === 'Некорректный токен') {
            this.redirect();
            return false;
        }
      }

      return true;
  }

  isError(response)
  {
      let dataType = response['response']['@xsi.type'] || null;
      return dataType == 'errorResponse';
  }

  errorMessage(response)
  {
      if(!this.isError(response)) {
        return null;
      }

      return response['response']['message'];
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/auth.utils.ts